import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { getIconColor } from "@/src/services/iconService";

const IconWrittenWarning = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m285.52,241.48c2.41,0,4.36-1.95,4.36-4.36v-122.98c0-1.24-.53-2.42-1.45-3.25l-33.42-29.88V27.24c0-9.15-7.45-16.6-16.6-16.6H61.58c-9.15,0-16.59,7.45-16.59,16.6v53.78l-33.41,29.87c-.92.83-1.45,2.01-1.45,3.25v38.61c0,2.41,1.95,4.36,4.36,4.36s4.36-1.95,4.36-4.36v-34.58l27.6,24.71,66.2,59.28h-.82c-1.06,0-2.08.38-2.87,1.08l-86.41,75.58c-2.24-1.67-3.7-4.33-3.7-7.32v-97.48c0-2.41-1.95-4.36-4.36-4.36s-4.36,1.95-4.36,4.36v97.48c0,7.5,4.65,13.92,11.21,16.56.05.02.1.03.15.05,2.02.79,4.2,1.24,6.49,1.24h244.05c2.31,0,4.52-.46,6.55-1.26.02,0,.05-.02.07-.03,6.57-2.64,11.23-9.06,11.23-16.57v-13.12c0-2.41-1.95-4.36-4.36-4.36s-4.36,1.95-4.36,4.36v13.12c0,3-1.46,5.66-3.69,7.33l-86.4-75.59c-.79-.7-1.81-1.08-2.87-1.08h-.82l66.19-59.27s0,0,0,0l27.6-24.72v118.95c0,2.41,1.95,4.36,4.36,4.36ZM44.99,129.88l-20.78-18.6,20.78-18.57v37.17Zm221.3,150.76H33.7l79.75-69.76h73.1l79.74,69.76Zm-20-142.94l-71.99,64.47h-48.59l-72-64.48V27.24c0-4.35,3.53-7.88,7.88-7.88h176.83c4.34,0,7.88,3.54,7.88,7.88v110.46Zm8.72-7.81v-37.19l20.78,18.58-20.78,18.61Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m210.05,142.99h-120.1c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25h120.1c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m176.59,169.77h-53.19c-2.35,0-4.25,1.9-4.25,4.25s1.9,4.25,4.25,4.25h53.19c2.35,0,4.25-1.9,4.25-4.25s-1.9-4.25-4.25-4.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m114.94,125.82h70.13c4.62,0,8.69-2.42,10.89-6.46,2.2-4.01,2.06-8.68-.36-12.54l-35.02-61.65c-.04-.07-.08-.13-.12-.19-2.3-3.58-6.2-5.72-10.45-5.72s-8.16,2.13-10.46,5.71c-.05.07-.09.14-.13.22l-35,61.62c-2.42,3.86-2.57,8.54-.37,12.55,2.21,4.05,6.29,6.46,10.9,6.46Zm-3.3-14.53c.04-.06.08-.13.12-.19l34.99-61.59c.73-1.09,1.94-1.74,3.26-1.74s2.51.64,3.24,1.73l35.01,61.62c.04.07.08.13.12.19.79,1.23.83,2.67.12,3.97-.7,1.29-1.95,2.03-3.43,2.03h-70.13c-1.48,0-2.73-.74-3.44-2.04-.71-1.29-.66-2.74.14-3.98Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m150,110.64c3.45,0,6.25-2.8,6.25-6.25s-2.8-6.25-6.25-6.25-6.25,2.8-6.25,6.25,2.8,6.25,6.25,6.25Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m150,92.4c4.01,0,6.25-19.07,6.25-23.08s-2.24-7.27-6.25-7.27-6.25,3.25-6.25,7.27,2.24,23.08,6.25,23.08Z"
      />
    </SvgIcon>
  );
};

export default IconWrittenWarning;